export default __webpack_public_path__ + "static/media/ink-transition3.48a4d583.jpg";